// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"183":"cae3bfbd17f2020c","625":"2ab8f9f638912742","941":"3a06058b78f125a5"}[chunkId] + ".js";
};